namespace Matrix.Workflow {
    export namespace WorkflowInstanceDocumentService {
        export const baseUrl = 'Workflow/WorkflowInstanceDocument';

        export declare function Create(request: Serenity.SaveRequest<WorkflowInstanceDocumentRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<WorkflowInstanceDocumentRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<WorkflowInstanceDocumentRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<WorkflowInstanceDocumentRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Workflow/WorkflowInstanceDocument/Create",
            Update = "Workflow/WorkflowInstanceDocument/Update",
            Delete = "Workflow/WorkflowInstanceDocument/Delete",
            Retrieve = "Workflow/WorkflowInstanceDocument/Retrieve",
            List = "Workflow/WorkflowInstanceDocument/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>WorkflowInstanceDocumentService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
